import { isString } from '@direct-frontend/stdlib';
import { type BaseQueryMeta } from '@adv-frontend/modules-query';

// Название файла приходит из данных в соответствующем заголовке
export const getFilenameFromHeader = (meta: BaseQueryMeta, fallbackFilename: string) => {
    const contentDisposition = meta.response?.headers?.['content-disposition'];

    let filename = fallbackFilename;

    if (isString(contentDisposition)) {
        const filenameMatch = contentDisposition.match(/filename=(.+)/) || [];

        if (filenameMatch.length > 1) {
            filename = filenameMatch[1];
        }
    }

    return filename;
};
